import { gql } from '@apollo/client'

export const MUTATION_CREATE_RETURN_LABEL = gql`
  mutation mutationCreateReturnLabel($input: CreateReturnLabelInput!) {
    createReturnLabel(input: $input) {
      trackingReference
      isDangerousGoods
      dangerousGoodsPdf
      showLabelComingSoon
    }
  }
`
